// extracted by mini-css-extract-plugin
module.exports = {"menuOpcoes":"MenuOpcoes_menuOpcoes__2E2eI","opcao":"MenuOpcoes_opcao__2TEOR","icone":"MenuOpcoes_icone__3qcuY","imagem":"MenuOpcoes_imagem__3pX5N"};